export default __webpack_public_path__ + "media/images/features/yado/step_2-56fa07676dfdd1782cf2c6e821b8c299.jpg";